import React from 'react';
import { groupItemsBy } from '../services/utils';

class AllowedUsers extends React.Component {
    isCompanyChecked(company_name) {
        const { users, allowedUsers } = this.props;
        return users.every(user => user.company_name !== company_name || allowedUsers.indexOf(user.id) > -1);
    }

    isAllChecked() {
        const { users, allowedUsers } = this.props;
        return users.every(user => allowedUsers.indexOf(user.id) > -1);
    }

    onChangeCompany(company_name) {
        const { users, allowedUsers, onChange } = this.props;
        
        return function (event) {
            const isChecked = event.target.checked;

            if (isChecked) {
                users.forEach(user => {
                    if (user.company_name === company_name && allowedUsers.indexOf(user.id) < 0) {
                        allowedUsers.push(user.id);
                    }
                });
            } else {
                users.forEach(user => {
                    if (user.company_name === company_name) {
                        const index = allowedUsers.indexOf(user.id);
                        if (index > -1) {
                            allowedUsers.splice(index, 1);
                        }
                    }
                });
            }

            onChange(allowedUsers);
        }
    }

    onChange(id) {
        const { allowedUsers, onChange } = this.props;

        return function (event) {
            const isChecked = event.target.checked;

            if (isChecked) {
                if (allowedUsers.indexOf(id) < 0) {
                    allowedUsers.push(id);
                }
            } else {
                const index = allowedUsers.indexOf(id);
                if (index > -1) {
                    allowedUsers.splice(index, 1);
                }
            }
            
            onChange(allowedUsers);
        }    
    }

    onChangeAll() {
        const { users, onChange } = this.props;

        return function (event) {
            const isChecked = event.target.checked;

            if (isChecked) {
                onChange(users.map(user => user.id));
            } else {
                onChange([])
            }
        }
    }

	render() {
        const { users, allowedUsers, style } = this.props;        
        const usersByCompany = groupItemsBy(users, 'company_name');

        return (
            <div style={style}>
                <div className='list-item-checkbox'>
                    <input 
                        type='checkbox'
                        checked={this.isAllChecked()}
                        onChange={this.onChangeAll()} />
                    <label className='checkbox-label'>Select/Deselect All</label>
                </div>
                {Object.entries(usersByCompany).map(entry => {
                    const users = entry[1];
                    const company_name = entry[0];
                    return (
                        <div key={company_name}>
                            <div className='list-item-checkbox'>
                                <input
                                    type='checkbox'
                                    name='allowed_users'
                                    checked={this.isCompanyChecked(company_name)}
                                    onChange={this.onChangeCompany(company_name)} />
                                <label htmlFor='allowed_users' className='checkbox-label'>{company_name}</label>
                            </div>
                            {users.map(user => 
                                <div className='indent-list-item-checkbox' key={user.id}>
                                    <input
                                        type='checkbox'
                                        name='allowed_users'
                                        checked={allowedUsers.indexOf(user.id) > -1}
                                        onChange={this.onChange(user.id)} />
                                    <label htmlFor='allowed_users' className='checkbox-label'>{user.name}</label>
                                </div>
                            )}
                        </div>
                    )   
                })}                
            </div>
        )
    }
}

export default AllowedUsers;



// WEBPACK FOOTER //
// ./source/components/allowedUsers.js